import { FC } from "react";
import Heart from "@/icons/__generated__/Heart/Heart24";
import HeartFilled from "@/icons/__generated__/HeartFilled/HeartFilled24";

interface SavedProps {
  interaction: () => void;
  isSaved: boolean;
}

export const Saved: FC<SavedProps> = ({ interaction, isSaved }) => {
  const savedOnClick = () => {
    interaction();
  };

  return (
    <div
      onClick={savedOnClick}
      onTouchStart={savedOnClick}
      className="tw-group/heart tw-justify-center tw-z-10 tw-absolute tw-text-base-white tw-right-12 tw-top-12 tw-flex tw-items-center tw-px-8 tw-py-4 tw-rounded-circular tw-w-32 tw-h-32 tw-bg-[rgba(18,18,18,0.65)] tw-pointer-events-none"
      data-testid="saved-icon"
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          e.stopPropagation();
          savedOnClick();
        }
      }}
    >
      {isSaved ? (
        <span className="tw-w-24 tw-h-24 tw-text-base-white hover:tw-text-gray-200 tw-pointer-events-auto">
          <HeartFilled />
        </span>
      ) : (
        <span className="tw-text-base-white hover:tw-text-gray-200 tw-pointer-events-auto tw-relative tw-inline-block">
          {/* Unfilled Heart Icon */}
          <div className="tw-w-24 tw-h-24 group-hover/heart:tw-hidden tw-block">
            <Heart />
          </div>
          {/* Filled Heart Icon */}
          <div className="tw-w-24 tw-h-24 group-hover/heart:tw-block tw-hidden">
            <HeartFilled />
          </div>
        </span>
      )}
    </div>
  );
};
